import { Link, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import Button from "../Lcomp/Button"; // Correct path for src/components/Lcomp/Button.jsx
import { CgMenuHotdog, CgClose } from "react-icons/cg";
import AOS from "aos";
import "aos/dist/aos.css";

const Navbar = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
  const [showChevronUp, setShowChevronUp] = useState(false);
  const [showMobileResources, setShowMobileResources] = useState(false);
  const [showMobileChevronUp, setShowMobileChevronUp] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const timeoutRef = useRef(null);
  const menuRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showMenu &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setShowMenu(false);
        setShowChevronUp(false);
        setShowMobileResources(false);
        setShowMobileChevronUp(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showMenu]);

  const toggleMenu = () => {
    console.log("Toggle menu clicked, current showMenu:", showMenu); // Debug log
    setShowMenu((prev) => !prev);
  };

  const closeMenu = () => {
    console.log("Close button clicked, setting showMenu to false"); // Debug log
    setShowMenu(false);
    setShowChevronUp(false);
    setShowMobileResources(false);
    setShowMobileChevronUp(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 50;
      setIsScrolled(scrollPosition > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDropdownMouseEnter = () => {
    clearTimeout(timeoutRef.current);
  };

  const handleDropdownMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMoreDropdown(false);
      setShowChevronUp(false);
    }, 200);
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const location = useLocation();
  const pathname = location.pathname;

  const handleLinkClick = () => {
    setShowMenu(false);
    setShowMoreDropdown(false);
    setShowChevronUp(false);
    setShowMobileResources(false);
    setShowMobileChevronUp(false);
  };

  const handleNewsClick = () => {
    if (pathname === "/") {
      const newsSection = document.getElementById("latest-news");
      if (newsSection) {
        newsSection.scrollIntoView({ behavior: "smooth" });
      }
    }
    handleLinkClick();
  };

  return (
    <nav
      className={`font-Lexend bg-primary_dark px-5 lg:px-16 py-4 lg:py-3 flex items-center justify-between text-[#fffff2] w-screen text-[16.5px] fixed left-0 top-0 z-50 transition-opacity duration-300 ${
        isScrolled ? "opacity-100 shadow-lg" : "opacity-90"
      }`}
    >
      {/* <Link to="/" onClick={handleLinkClick}>
        <div className="w-40 h-auto">
          <img src="/assets/bmt/main_logo.png" alt="BMT Logo" className="object-contain" />
        </div>
      </Link> */}
      <Link to="/" onClick={handleLinkClick}>
        <div className="flex items-center w-40 h-auto">
          {/* Logo 1 */}
          <img
            src="./assets/bmt/scfn_logo2.PNG"
            alt="LUTH Logo"
            className="h-12 w-auto object-contain"
          />

          {/* Divider */}
          <div className="mx-2 h-6 w-[2px] bg-white/70 rounded-full" />

          {/* Logo 2 */}
          <img
            src="./assets/bmt/luth_logo2.PNG"
            alt="SFCN Logo"
            className="h-8 w-auto object-contain"
          />
        </div>
      </Link>

      {/* Mobile Menu */}
      <div
        ref={menuRef}
        className={`lg:hidden fixed left-0 top-[72px] w-full bg-white text-[#232323] flex flex-col items-start gap-6 font-Lexend h-[calc(100vh-72px)] px-6 py-8 shadow-md border-t border-slate-100 text-base transition-transform duration-300 ease-in-out overflow-y-auto ${
          showMenu ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ zIndex: 40 }}
      >
        <Link
          onClick={handleLinkClick}
          to="/"
          className={
            pathname === "/"
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          Home
        </Link>
        <Link
          onClick={handleLinkClick}
          to="/about"
          className={
            pathname === "/about"
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          About
        </Link>
        <Link
          onClick={handleLinkClick}
          to="/services"
          className={
            pathname === "/services"
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          Services
        </Link>
        <Link
          onClick={handleLinkClick}
          to="/gallery"
          className={
            pathname === "/gallery"
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          Gallery
        </Link>
        <Link
          onClick={handleLinkClick}
          to="/contact"
          className={
            pathname === "/contact"
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          Contact
        </Link>
        <Link
          onClick={handleNewsClick}
          to="/#latest-news"
          className={
            pathname.includes("#latest-news")
              ? "active_class"
              : "hover:text-slate-500 transition-all"
          }
        >
          News & Media
        </Link>
        <div
          className="relative cursor-pointer hover:text-slate-500 transition-all w-full"
          onClick={(e) => {
            e.stopPropagation();
            setShowMobileResources(!showMobileResources);
            setShowMobileChevronUp(!showMobileChevronUp);
          }}
        >
          <div className="flex items-center gap-3">
            <span>Resources</span>
            {showMobileChevronUp ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          <div
            className={`flex flex-col text-primary_dark font-Lexend pt-4 space-y-2 w-full ${
              showMobileResources ? "block" : "hidden"
            }`}
          >
            <a
              href="./assets/bmt/Brochure.pdf"
              rel="noopener noreferrer"
              className="block hover:text-slate-700 transition-all py-2 whitespace-nowrap"
              onClick={handleLinkClick}
            >
              Brochure
            </a>
            <Link
              to="/education"
              onClick={handleLinkClick}
              className={
                pathname === "/education"
                  ? "active_class block py-2 whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all py-2 whitespace-nowrap"
              }
            >
              Education & Awareness
            </Link>
            <Link
              to="/research"
              onClick={handleLinkClick}
              className={
                pathname === "/research"
                  ? "active_class block py-2 whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all py-2 whitespace-nowrap"
              }
            >
              Research & Innovation
            </Link>
            <Link
              to="/whattoexpect"
              onClick={handleLinkClick}
              className={
                pathname === "/whattoexpect"
                  ? "active_class block py-2 whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all py-2 whitespace-nowrap"
              }
            >
              Patient Information
            </Link>
            <Link
              to="/faq"
              onClick={handleLinkClick}
              className={
                pathname === "/faq"
                  ? "active_class block py-2 whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all py-2 whitespace-nowrap"
              }
            >
              FAQ
            </Link>
          </div>
        </div>
        <Link to="/donation" onClick={handleLinkClick}>
          <Button
            classes="px-8 py-2 bg-primary_red font-Lexend font-bold rounded-[4px] text-base hover:bg-primary_red/80 transition-all tracking-wide text-white w-full"
            text="Donate Now"
          />
        </Link>
      </div>

      {/* Desktop Menu */}
      <ul className="hidden lg:flex items-center justify-center gap-12 font-Lexend w-full ml-10">
        <Link
          to="/"
          className={
            pathname === "/"
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          Home
        </Link>
        <Link
          to="/about"
          className={
            pathname === "/about"
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          About
        </Link>
        <Link
          to="/services"
          className={
            pathname === "/services"
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          Services
        </Link>
        <Link
          to="/gallery"
          className={
            pathname === "/gallery"
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          Gallery
        </Link>
        <Link
          to="/contact"
          className={
            pathname === "/contact"
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          Contact
        </Link>
        <Link
          to="/#latest-news"
          onClick={handleNewsClick}
          className={
            pathname.includes("#latest-news")
              ? "active_class"
              : "hover:text-slate-300 transition-all"
          }
        >
          News & Media
        </Link>
        <div
          className="relative cursor-pointer hover:text-slate-300 transition-all"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
          onClick={() => {
            setShowMoreDropdown(!showMoreDropdown);
            setShowChevronUp(!showChevronUp);
          }}
        >
          <div className="flex items-center gap-3">
            <span>Resources</span>
            {showChevronUp ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          <div
            className={`absolute left-0 top-full mt-2 bg-white text-primary_dark font-Lexend p-4 min-w-[200px] flex flex-col space-y-4 shadow-md rounded-[8px] ${
              showMoreDropdown ? "block" : "hidden"
            }`}
          >
            <a
              href="./assets/bmt/Brochure.pdf"
              rel="noopener noreferrer"
              className="block hover:text-slate-700 transition-all whitespace-nowrap"
            >
              Brochure
            </a>
            <Link
              to="/education"
              className={
                pathname === "/education"
                  ? "active_class block whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all whitespace-nowrap"
              }
            >
              Education & Awareness
            </Link>
            <Link
              to="/research"
              className={
                pathname === "/research"
                  ? "active_class block whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all whitespace-nowrap"
              }
            >
              Research & Innovation
            </Link>
            <Link
              to="/whattoexpect"
              className={
                pathname === "/whattoexpect"
                  ? "active_class block whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all whitespace-nowrap"
              }
            >
              Patient Information
            </Link>
            <Link
              to="/faq"
              className={
                pathname === "/faq"
                  ? "active_class block whitespace-nowrap"
                  : "block hover:text-slate-700 transition-all whitespace-nowrap"
              }
            >
              FAQ
            </Link>
          </div>
        </div>
      </ul>

      <div className="hidden lg:block w-max pl-12">
        <Link to="/donation">
          <Button
            classes="px-12 py-4 bg-primary_red font-Lexend font-bold rounded-[4px] text-[15px] hover:bg-primary_red/80 transition-all tracking-wide"
            text="Donate Now"
          />
        </Link>
      </div>

      <div className="lg:hidden absolute right-5 top-1/2 -translate-y-1/2 z-50">
        {showMenu ? (
          <CgClose
            className="w-10 h-10 cursor-pointer bg-primary_red rounded-full p-2 pointer-events-auto"
            onClick={(e) => {
              e.stopPropagation();
              closeMenu();
            }}
          />
        ) : (
          <CgMenuHotdog
            className="w-10 h-10 cursor-pointer bg-primary_red rounded-full p-2 pointer-events-auto"
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu();
            }}
          />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
